import { motion } from "framer-motion";

export const IMAGES = {
  hero: "https://customer-assets-m6fa6gv7.emergentagent.net/job_wedding-details-12/artifacts/8c3d4093b3f6e263_Copy%20of%20Copy%20of%20Copy%20of%20Copy%20of%20Copy%20of%20Copy%20of%20Copy%20of%20Nostalgic%20Save%20the%20Date%20postcard%20template%20%284.5%20x%206.25%20in%29.webp",
  mantel: "https://customer-assets-m6fa6gv7.emergentagent.net/job_wedding-details-12/artifacts/26aoqecf_930478b5-f2a4-4942-8ec9-28f3bf662c97.jpg",
  invite: "https://customer-assets-m6fa6gv7.emergentagent.net/job_wedding-details-12/artifacts/7zukzqhv_Copy%20of%20Copy%20of%20Nostalgic%20Save%20the%20Date%20postcard%20template%20%282%29.webp",
  weekend: "https://customer-assets-m6fa6gv7.emergentagent.net/job_wedding-details-12/artifacts/0n8otbfd_download.jpeg",
  fireplace: "https://images.pexels.com/photos/16278430/pexels-photo-16278430.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  disco: "https://images.unsplash.com/photo-1560987617-6de57e3d0574?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxyZXRybyUyMDcwcyUyMGRpc2NvJTIwYmFsbCUyMHBhcnR5fGVufDB8fHx8MTc4NzE4NjUyMHww&ixlib=rb-4.1.0&q=85",
  flowers: "https://images.unsplash.com/photo-1662583881825-81e128754cb7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxwYXBlciUyMGZsb3dlcnMlMjBjb2xvcmZ1bCUyMHJldHJvfGVufDB8fHx8MTc4NzE4NjUyMHww&ixlib=rb-4.1.0&q=85",
};

export const SWATCHES = [
  { name: "Burnt Orange", hex: "#FF6E00" },
  { name: "Avocado", hex: "#9C8A30" },
  { name: "Oxblood", hex: "#B31924" },
  { name: "Basement Bar Brown", hex: "#6E523A" },
  { name: "Bubblegum", hex: "#FFA9D2", secondary: true },
  { name: "Daffodil", hex: "#FFDA29", secondary: true },
  { name: "Powder Blue", hex: "#96D8E8", secondary: true },
];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);
